import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { LinearProgress, Typography } from '@mui/material';

import { Formik } from 'formik';
import { AppPrimaryButton } from 'shared/components/AppComponents';

const DownloadModal: React.FC<Props> = React.forwardRef(
    (
        { callbackClosingModal, callbackOpenModal, content },
        ref
    ): React.ReactElement => {
        const [open, setOpen] = React.useState(false);

        const handleOpen = React.useCallback((): void => {
            setOpen(true);
            if (typeof callbackOpenModal === 'function') callbackOpenModal();
        }, [callbackOpenModal]);

        const handleClose = React.useCallback(() => {
            setOpen(false);
            if (typeof callbackClosingModal === 'function')
                callbackClosingModal();
        }, []);
        React.useImperativeHandle(
            ref,
            () => ({
                setClose: () => {
                    handleClose();
                },
                setOpen: () => {
                    handleOpen();
                },
                // setReason: (message: string) => {
                //     setReason(message);
                // },
            }),
            [handleOpen, handleClose]
        );
        return (
            <Box>
                <Modal
                    open={open}
                    onClose={handleClose}
                    disableEscapeKeyDown
                    disableScrollLock
                    aria-labelledby="parent-modal-title"
                    aria-describedby="parent-modal-description"
                >
                    <Box className="container-escalated-modal">
                        <Typography
                            variant="h6"
                            id="parent-modal-title"
                            padding={5}
                        >
                            {content}
                        </Typography>

                        <Box padding={3}>
                            <LinearProgress
                                color="secondary"
                                variant="indeterminate"
                            />
                        </Box>
                        <Box className="escalated-solicitor-action">
                            <Formik
                                initialValues={{
                                    smallInput: 'Insert Here',
                                }}
                                enableReinitialize
                                onSubmit={() => {
                                    // console.log('');
                                }}
                            >
                                <Box className="containerButton">
                                    <AppPrimaryButton
                                        title="Cancel"
                                        className="btn-small back-button"
                                        onClick={handleClose}
                                    />
                                </Box>
                            </Formik>
                        </Box>
                    </Box>
                </Modal>
            </Box>
        );
    }
);

export default DownloadModal;
